module.exports = __webpack_public_path__ + "img/designBanner.ef62d62e.jpg";